import React from "react";
import { useTranslation } from "react-i18next";

const COPY = {
  about: { title: "About Boom Mode", body: "Boom Mode is a European leather house dedicated to refined essentials. Founded in 2024, we work with Italian artisans to produce timeless handbags and wallets at a fair, modern price. Quiet luxury, made for now." },
  shipping: { title: "Shipping Policy", body: "We offer express shipping across Europe (2–4 business days). Free over €150. All packages tracked & insured." },
  returns: { title: "Return Policy", body: "30-day free returns on unworn items in original packaging. Refunds processed within 5 business days." },
  privacy: { title: "Privacy Policy", body: "We respect your data. We only collect what we need to process orders and improve your shopping experience. We never sell your data." },
  terms: { title: "Terms & Conditions", body: "By purchasing from Boom Mode you agree to our terms. Disputes are governed by EU consumer law." },
  contact: { title: "Contact", body: "For any question, email hello@boommode.com or write to us through Instagram @boommode. We respond within 24 hours, 7 days a week." },
  faq: { title: "FAQ", body: "Q: Are your products genuine leather? A: Yes — full-grain Italian leather. Q: How long is shipping? A: 2–4 business days across Europe. Q: Do you ship to the UK? A: Yes, with EUR or GBP pricing." }
};

export default function StaticPage({ page }) {
  const c = COPY[page] || { title: "", body: "" };
  return (
    <section className="py-16 lg:py-24" data-testid={`static-${page}`}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="eyebrow">Boom Mode</div>
        <h1 className="font-serif-bm text-4xl md:text-5xl mt-3">{c.title}</h1>
        <p className="text-base text-[var(--bm-ink-2)] mt-6 leading-relaxed whitespace-pre-line">{c.body}</p>
      </div>
    </section>
  );
}
